module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('range', {
    attrs: {
      "label": _vm.$t('edit.sidebar.font_size'),
      "min": "12",
      "max": "32",
      "step": "1",
      "value": _vm.value(),
      "change": _vm.onChange,
      "move": _vm.onMove
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-34f89694!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/triggerbutton/FontSize.vue
 ** module id = 798
 ** module chunks = 1
 **/